module.exports = __webpack_public_path__ + "static/media/all.e4381c4c.pred";